const ApiKeys = {
    BASE_URL: process.env.VUE_APP_BASE_URL,
    IMAGE_BASE_URL : process.env.VUE_APP_IMAGE_BASE_URL
 };
 export default ApiKeys;